<template>
  <div class="cpt-dynamic-bg" v-show="!isScreenshot">
    <div class="video-wrapper" :class="{ ready: isReady }">
      <video
        class="video-bg"
        muted
        loop
        autoplay="autoplay"
        preload="auto"
        playsinline="true"
        webkit-playsinline="true"
        mtt-playsinline="true"
        x5-video-player-type="h5-page"
        @canplaythrough="isReady = true"
        poster="https://imgheybox.max-c.com/oa/2025/01/23/df1cbe6f77daacd327e1693db3c2fd4d.png"
        ref="bg-video"
      >
        <source :src="videoUrl" type="video/mp4" />
      </video>
      <div class="video-poster" @click="playVideo">
        <img v-src="'https://imgheybox.max-c.com/oa/2025/01/23/df1cbe6f77daacd327e1693db3c2fd4d.png'" alt="">
      </div>
      <div class="color-mask"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isScreenshot: {
      type: Boolean,
      default: false,
    },
    videoUrl: {
      type: String,
      default:
        'https://static.max-c.com/static/heybox/webapp/spring_festival_2025/spring_festival_2025_header_v3.mp4',
    },
  },
  data() {
    return {
      isReady: false,
      showMask: true,
    };
  },
  watch: {
    isReady(n) {
      if (n) {
        this.$emit('bgIsReady')
        document.addEventListener(
          'touchstart',
          () => {
            this.$refs['bg-video'].play()
          },
          { once: true },
        );
      }
    },
  },
  mounted() {
    document.addEventListener(
      'touchstart',
      () => {
        this.$refs['bg-video'].play()
      },
      { once: true },
    );
  },
  methods: {
    playVideo() {
      this.showMask = false;
      this.$refs['bg-video'].play();
    },
  },
};
</script>

<style lang="less">
.cpt-dynamic-bg {
  position: relative;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  max-height: 100vh;
  overflow: hidden;
  .video-wrapper {
    position: relative;
    width: 100%;
    padding-top: calc(960 / 1126 * 100%);
    z-index: 1;
    .video-poster {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &.ready {
      opacity: 1;
    }
    .video-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      z-index: 3;
    }
    .color-mask {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 15px;
      background: linear-gradient(180deg, rgba(255, 228, 214, 0) 0%, rgba(255, 228, 214, 1) 100%);
      z-index: 4;
    }
  }
}
</style>
